import React from "react";
import PropTypes from "prop-types";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./BasketModificationModal.css";

export default class BasketModificationModal extends React.Component {
  
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    itemName: PropTypes.string
  }
  
  static defaultProps = {
    itemName: "item"
  }
  
  cancel = () => {
    this.props.onClose(false);
  }
  
  remove = () => {
    this.props.onClose(true);
  }
  
  render() {
    
    const { isOpen, itemName } = this.props;
    
    return (
      <ModalDialog isOpen={isOpen}>
        <div className="basket-modification-modal">
          <div className="basket-modification-modal__heading">Attention</div>
          <div className="basket-modification-modal__body">
            <p>This {itemName} has already been added to the basket. Making changes to this {itemName} will remove it from the basket.</p>
            <p>Are you sure you wish to continue?</p>
          </div>
          <div className="basket-modification-modal__button-container">
            <Button className="basket-modification-modal__cancel-button" onClick={this.cancel}>Cancel</Button>
            <Button className="basket-modification-modal__remove-button" onClick={this.remove}>Remove</Button>
          </div>
        </div>
      </ModalDialog>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/BasketModificationModal.js